<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'LevelClear',
  data () {
    return {
      count: 0
    };
  },
  mounted () {
    const pic1 = window.document.getElementById('image1');
    const pic2 = window.document.getElementById('image2');
    const pic3 = window.document.getElementById('image3');
    const pic4 = window.document.getElementById('image4');
    if (pic1 && pic2 && pic3 && pic4) {
      pic1.style.height = pic1.offsetWidth * 1.95 + 'px';
      pic2.style.height = pic2.offsetWidth * 1.95 + 'px';
      pic3.style.height = pic3.offsetWidth * 1.95 + 'px';
      pic4.style.height = pic4.offsetWidth * 1.95 + 'px';
    }
    this.$emit('scroll');
    this.$emit('load');
  },
  components: {
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'routeAddress',
      'newDay2ContentAddress'
    ])
  },
  methods: {
    goBack () {
      if (this.newDay2ContentAddress === 'RofT') {
        router.push({ path: '/timeline/recommendation/RofT' });
        return;
      }
      switch (this.routeAddress) {
        case 'galaxy':
          router.push({ path: '/timeline/recommendation/0001' });
          break;
        case 'android':
          router.push({ path: '/timeline/recommendation/0002' });
          break;
        case 'ios':
          router.push({ path: '/timeline/recommendation/0003' });
          break;
        case 'xperia':
          router.push({ path: '/timeline/recommendation/0004' });
          break;
      }
    }
  }
});
</script>

<template>
  <div class="setting">
      <div class="setting__title-text">{{ $t('settingText') }}</div>
      <div class="phone">{{ $t('forAndroid') }}</div>
      <div class="phone__details">
          <span class="phone__details-number">1</span>
          <div class="phone__details-text">{{ $t('openGoogleApp') }}</div>
      </div>
      <img class="picture" id="image1" src="../../assets/interactive/img-android-1.jpg"/>
      <div class="phone__details">
          <span class="phone__details-number">2</span>
          <div class="phone__details-text">{{ $t('clickTrimming') }}</div>
      </div>
      <img class="picture" id="image2" src="../../assets/interactive/img-android-2.jpg"/>
      <div class="phone">{{ $t('forIphone') }}</div>
      <div class="phone__details">
          <span class="phone__details-number">1</span>
          <div class="phone__details-text">{{ $t('openPhotoIos') }}</div>
      </div>
      <img class="picture" id="image3" src="../../assets/interactive/img-ios-1.jpg"/>
      <div class="phone__details">
          <span class="phone__details-number">2</span>
          <div class="phone__details-text">{{ $t('clickTrimmingIos') }}</div>
      </div>
      <img class="picture" id="image4" src="../../assets/interactive/img-ios-2.jpg"/>
      <Button
        class="button"
        :size="'large'"
        :text="$t('previous')"
        @click="goBack()"
      />
  </div>
</template>

<style lang="scss" scoped>
.setting {
  display: flex;
  flex-direction: column;
  padding: 40px 0;
}
.phone {
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
    margin: 20px 0;
    &__details {
        display: flex;
        flex-direction: row;
        &-number {
            font-size: 12px;
            font-weight: bold;
            min-width: 20px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #d8d8d8;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 2px 9px 0 0;
        }
        &-text {
            font-weight: bold;
        }
    }
}
.picture {
  width: calc(100vw - 120px);
  // 1.95 Ratio
  height: calc(195vw - 234px);
  margin: 17px 40px 28px;
}
.button {
  margin: 32px 0;
}
@media screen and (min-width:440px) {
  .picture {
    width: calc(100% - 80px);
    align-self: center;
  }
}
</style>
